import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { Link } from 'react-router-dom';

import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Visibility, Add, LocalOfferSharp } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { WithApp } from 'contexts/appContext';
import Button from 'components/CustomButtons/Button.js';
import CardIcon from 'components/Card/CardIcon';
import { Fragment } from 'react';
import ButtonDelete from 'hooks/ButtonDelete';
import { wsFindBy } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
  },
  totals: {
    fontWeight: 'bold',
    width: '170px',
  },
});

const promotionTableColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 140 },
  { Header: 'ID', accessor: 'idPromotion', width: 100 },
  { Header: 'Canal', accessor: 'canals', width: 80 },
  { Header: 'Zonas', accessor: 'zones', width: 120, align: 'center' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Límite', accessor: 'limit', width: 100 },
  { Header: 'Asignado', accessor: 'asig', width: 100 },
  { Header: 'Disponible', accessor: 'disp', width: 100 },
  { Header: 'Tipo compra', accessor: 'evaluation_type', width: 140 },
  { Header: 'Tipo bono', accessor: 'bonification_type', width: 130 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: 'Desde', accessor: 'start_date', width: 110 },
  { Header: 'Hasta', accessor: 'end_date', width: 110 },
  { Header: 'Cond. Venta', accessor: 'sale_condition', width: 140, align: 'center' },
  { Header: 'Origen', accessor: 'origin', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const states = [
  { value: 'P', name: 'Aprobado' },
  { value: 'V', name: 'Vigente' },
  { value: 'L', name: 'Liquidado' },
  { value: 'I', name: 'Inactivo' },
  { value: 'G', name: 'Generado' },
  { value: 'N', name: 'Nuevo' },
  { value: 'C', name: 'Cancelado' },
];

function mapComboData(combo, i, listCombos, classes) {
  let origin = '';
  switch (combo.origin) {
    case 'E':
      origin = 'Externo';
      break;
    case 'I':
      origin = 'Interno';
      break;
    default:
      origin = combo.origin;
  }
  let state = '';
  switch (combo.state) {
    case 'P':
      state = 'Aprobado';
      break;
    case 'V':
      state = 'Vigente';
      break;
    case 'L':
      state = 'Liquidado';
      break;
    case 'I':
      state = 'Inactivo';
      break;
    case 'G':
      state = 'Generado';
      break;
    case 'N':
      state = 'Nuevo';
      break;
    case 'C':
      state = 'Cancelado';
      break;
    default:
      state = combo.state;
  }

  let evaluation_type = '';
  switch (combo.evaluation_type) {
    case 'P':
      evaluation_type = 'Producto';
      break;
    case 'S':
      evaluation_type = 'Proveedor';
      break;
    case 'C':
      evaluation_type = 'Categoría';
      break;
    case 'F':
      evaluation_type = 'Familia';
      break;
    default:
      evaluation_type = combo.evaluation_type;
  }

  let bonification_type = '';
  switch (combo.bonification_type) {
    case 'P':
      bonification_type = 'Producto';
      break;
    case 'D':
      bonification_type = 'Descuento %';
      break;
    case 'S':
      bonification_type = 'Descuento S./';
      break;
    default:
      bonification_type = combo.bonification_type;
  }

  let limit = combo.limit_promotion;
  let limitForCalculed = combo.limit_promotion;

  let asig = combo.advance_promotion;

  let sale_condition = '';
  switch (combo.sale_condition) {
    case 'A':
      sale_condition = 'Ambos';
      break;
    case 'C':
      sale_condition = 'Contado';
      break;
    case 'R':
      sale_condition = 'Crédito';
      break;
    default:
      sale_condition = combo.sale_condition;
  }

  return {
    num: (
      <div className="actions-right">
        {i + 1}
        <AllowedGuard permission={ConstantPermissions.PROM_PROMOTIONS_SHOW}>
          <Button justIcon round simple color="info" className="like">
            <Link to={`${combo.id}`}>
              <Visibility />
            </Link>
          </Button>
        </AllowedGuard>
        <AllowedGuard permission={ConstantPermissions.PROM_PROMOTIONS_DELETED}>
          <ButtonDelete entity="prom/promotion" id={combo.id} reload={listCombos} />
        </AllowedGuard>
      </div>
    ),
    idPromotion: String(combo.id),
    canals: combo.canals,
    zones: combo.zones.map((item) => item.code).toString(),
    CardName: combo.CardName,
    description: combo.description,

    limit,
    asig,
    disp: limitForCalculed - asig,

    evaluation_type,
    bonification_type,
    start_date: combo.start_date,
    end_date: combo.end_date,
    sale_condition,
    origin,
    state,
    actions: '',
  };
}

export default WithApp(function ComboList(props) {
  const classes = useStyles();
  const [combos, setCombos] = useState([]);
  const [state, setState] = useState(states[0]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listCombos(filters) {
    setDataLoading(true);
    let response = await wsFindBy('prom/combo', { state: state.value, ...filters });
    setDataLoading(false);
    if (response.success) setCombos(response.data);
  }

  useEffect(() => {
    listCombos();
  }, [state]);

  return (
    <Fragment>
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.PROM_PROMOTIONS_STORE}
            component={
              <CardIcon color="primary">
                <LocalOfferSharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <Link to="0">
              <CardIcon pointer="true" color={props.themeContext.buttonColorSuccess}>
                <Add style={{ color: 'white' }} />
              </CardIcon>
            </Link>
          </AllowedGuard>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: 'black' }}>
            <span className={classes.cardIconTitle}>Combos {dataLoading && <LoadingSpinner />}</span>
                
            <div className={classes.totals}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Estado</InputLabel>
                <Select
                  value={state.value || ''}
                  inputProps={{
                    name: 'value',
                  }}
                >
                  {states.map((item, i) => {
                    return (
                      <MenuItem value={item.value} key={i} onClick={() => setState(item)}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <FilterCustom provider getFilter={listCombos} />
          <ReactTable
            excelName="Combos"
            formatDate="DD-MM-YYYY"
            heightRow={50}
            defaultWidth={2100}
            columns={promotionTableColumns}
            data={combos.map((item, index) =>
              mapComboData(item, index, listCombos, classes),
            )}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
